import { FC } from 'react';
import {
  GotoBlackYellowIcon,
  GotoWhiteYellowIcon,
  LogmeinBlackYellowIcon,
  LogmeinWhiteYellowIcon,
} from '@getgo/chameleon-icons/react';

import { useAppSelector } from 'hooks';
import { isGotoClient, isLogmeinClient } from 'modules/session-details';
import { SEARCH_PARAMS, THEMES } from 'utils/constants';

const ClientLogo: FC = () => {
  const globalTheme = localStorage.getItem(SEARCH_PARAMS.theme);

  const selectedClientIsLogmein = useAppSelector(isLogmeinClient);
  const selectedClientIsGoto = useAppSelector(isGotoClient);

  if (globalTheme?.toUpperCase() === THEMES.dark) {
    if (selectedClientIsLogmein) {
      return <LogmeinWhiteYellowIcon />;
    } else if (selectedClientIsGoto) {
      return <GotoWhiteYellowIcon />;
    } else {
      return <></>;
    }
  } else {
    if (selectedClientIsLogmein) {
      return <LogmeinBlackYellowIcon />;
    } else if (selectedClientIsGoto) {
      return <GotoBlackYellowIcon />;
    } else {
      return <></>;
    }
  }
};

export default ClientLogo;
